
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { CargoV2Controller } from "@/app/ui/controllers/CargoV2Controller";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { OptionsClass } from "@/domain/entities/MainApp";
import { Vue, Options, prop } from "vue-class-component";

class Props {
  originCityCode = prop<string>({
    default: "",
    type: String
  });
  destinationCityCode = prop<string>({
    default: "",
    type: String
  });
  disabledSelectSchedule = prop<boolean>({
    default: false,
    type: Boolean
  });
  disabledBooking = prop<boolean>({
    default: false,
    type: Boolean
  });
  disabledChangeTransport = prop<boolean>({
    default: false,
    type: Boolean
  });
  showSelectSchedule = prop<boolean>({
    default: true,
    type: Boolean
  });
}

@Options({
  components: {},
  watch: {
    payloadTransportType: {
      handler(payload: any) {
        if (payload.origin && payload.destination) {
          this.fetchCargoTransportType();
        }
      },
      deep: true,
      immediate: true
    }
  }
})
class CargoV2EditHeaderActions extends Vue.with(Props) {
  isLoadingCargoType = false;
  cargoTypeOptions: OptionsClass[] = [];

  get payloadTransportType() {
    return {
      origin: this.originCityCode,
      destination: this.destinationCityCode
    };
  }

  handleSelectModa(moda: string) {
    this.isOpenModa = false;
    this.$emit("select-moda", moda);
  }

  handleSelectSchedule() {
    this.$emit("select-schedule");
  }

  handleBooking() {
    this.$emit("booking");
  }

  // Moda section
  isOpenModa = false;
  toggleModa() {
    this.isOpenModa = !this.isOpenModa;
  }

  mapCargoTypeLabel(label: string) {
    const obj = {
      "Cargo Plane": this.$t("cargoV2.components.common.plane"),
      "Cargo Truck": this.$t("cargoV2.components.common.truck"),
      "Cargo Ship": this.$t("cargoV2.components.common.ship"),
      "Cargo Train": this.$t("cargoV2.components.common.train")
    } as any;

    return obj[label];
  }

  get form() {
    return CargoV2Controller.form;
  }

  get getCargoTypeOptions() {
    return this.cargoTypeOptions.filter((option) => {
      return option.value !== this.form.cargoType.value;
    });
  }

  async fetchCargoTransportType() {
    try {
      this.isLoadingCargoType = true;
      const resp = await CargoV2Controller.getCargoTransportType(
        this.payloadTransportType
      );
      this.cargoTypeOptions = resp
        .filter((ct) => ct.transportType !== "train")
        .map((ct) => {
          return new OptionsClass({
            label: this.mapCargoTypeLabel(ct.transportLabel),
            value: ct.transportType
          });
        });
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          this.$t("cargoV2.create.cargoType.error.getListCargoType.title"),
          () => this.fetchCargoTransportType()
        )
      );
    } finally {
      this.isLoadingCargoType = false;
    }
  }
}

export default CargoV2EditHeaderActions;
